import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Icon } from 'bench-internal-theme';

type DrawerProps = {
  header: string;
  open: boolean;
  onClose: () => void;
  children?: React.ReactElement | React.ReactElement[];
};

const OuterContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  height: 100%;
  z-index: 2;
`;

const BackDropContainer = styled.div<{ isOpen: boolean }>`
  background-color: black;
  opacity: ${props => (props.isOpen ? '0.5' : '0')};
  transition: 200ms;
  flex: 1;
`;

const Container = styled.div<{ isOpen: boolean }>`
  margin-right: ${props => (props.isOpen ? 'none' : '-500px')};
  transition: 200ms;
  flex: 1;
  min-width: 270px;
  max-width: 500px;
  background-color: white;
`;

const Header = styled.div`
  color: white;
  font-weight: bold;
  background: linear-gradient(165deg, rgba(228, 109, 241, 1) 0%, rgba(73, 63, 220, 1) 80%);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 25px;
  user-select: none;
`;

const HeaderColumn = styled.div`
  display: flex;
  align-items: center;
`;

const HeaderIcon = styled(Icon)`
  margin-right: 10px;
`;

const HeaderText = styled.div`
  padding-right: 15px;
`;

const CloseButton = styled(Icon)`
  border: 2px solid white;
  border-radius: 8px;
  cursor: pointer;
  opacity: 0.7;
  transition: 200ms;

  &:hover {
    opacity: 1;
  }
`;

const ContentContainer = styled.div`
  padding: 25px;
`;

const Drawer = ({ header, open, onClose, children }: DrawerProps) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setIsOpen(open);
    }, 100);
  }, [open]);

  const handleOnClose = () => {
    setIsOpen(false);
    setTimeout(() => {
      onClose();
    }, 200);
  };
  return (
    <OuterContainer>
      <BackDropContainer isOpen={isOpen} onClick={() => handleOnClose()} />
      <Container isOpen={isOpen}>
        <Header>
          <HeaderColumn>
            <HeaderIcon icon={'pencil'} color={'white'} />
            <HeaderText>{header}</HeaderText>
          </HeaderColumn>
          <HeaderColumn>
            <CloseButton onClick={() => handleOnClose()} icon={'close'} color={'white'} />
          </HeaderColumn>
        </Header>
        <ContentContainer>{children}</ContentContainer>
      </Container>
    </OuterContainer>
  );
};

export default Drawer;
